import { render, staticRenderFns } from "./ChampionshipBracketSkeleton.vue?vue&type=template&id=0fa26aba&scoped=true"
import script from "./ChampionshipBracketSkeleton.vue?vue&type=script&lang=js"
export * from "./ChampionshipBracketSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ChampionshipBracketSkeleton.vue?vue&type=style&index=0&id=0fa26aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa26aba",
  null
  
)

export default component.exports